import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Platform, TextInput } from 'react-native';

/** A short text or number field of a style option. */
export const StyleTextInput = memo(
  ({
    label,
    value,
    placeholder,
    numeric,
    maxLength = 40,
    onChange,
  }: {
    label: string;
    value: string;
    placeholder?: string;
    numeric?: boolean;
    maxLength?: number;
    onChange: (text: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TextInput
        accessibilityLabel={label}
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        placeholderTextColor={aiColors.mutedForeground}
        // iOS's numeric pad has no minus sign, and an axis may start below 0.
        keyboardType={
          !numeric
            ? 'default'
            : Platform.OS === 'ios'
            ? 'numbers-and-punctuation'
            : 'numeric'
        }
        maxLength={maxLength}
        style={{
          flexGrow: numeric ? 0 : 1,
          width: numeric ? rpx(88) : undefined,
          minWidth: rpx(88),
          height: rpx(32),
          paddingHorizontal: rpx(10),
          borderRadius: rpx(8),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.input,
          color: aiColors.foreground,
          fontSize: rpx(12),
        }}
      />
    );
  },
);
